/**
 * Similar to the structure of ../../JobDrawer
 * The hierarchy of components here is:
 * CreateTriggerDrawer - thin wrapper to allow animated drawer transition without loading content
 * CreateTriggerDrawerInner - queries for data, shows loading indicator
 * CreateTriggerDrawerLoaded - UI the user interacts with
 */
import Drawer from '@material-ui/core/Drawer';
import React from 'react';

import {OptionType} from '../utils';
import * as S from './CreateTriggerDrawer.styles';
import {CreateTriggerDrawerInner} from './CreateTriggerDrawerInner';

type CreateTriggerDrawerProps = {
  open: boolean;
  closeDrawer: () => void;

  entityName: string;
  projectName: string;
  projectID: string;
  artifactCollectionID?: string;
  refetchProjectTriggers: () => Promise<any>;
  refetchCollectionTriggers?: () => Promise<any>;
  customTriggerOptions?: OptionType[];
};

export const CreateTriggerDrawer = ({
  entityName,
  projectName,
  projectID,
  artifactCollectionID,
  refetchProjectTriggers,
  refetchCollectionTriggers,
  open,
  closeDrawer,
  customTriggerOptions,
}: CreateTriggerDrawerProps) => {
  return (
    <Drawer anchor="right" open={open} onClose={closeDrawer}>
      <S.DrawerContents>
        <CreateTriggerDrawerInner
          entityName={entityName}
          projectName={projectName}
          projectID={projectID}
          artifactCollectionID={artifactCollectionID}
          onClose={closeDrawer}
          refetchProjectTriggers={refetchProjectTriggers}
          refetchCollectionTriggers={refetchCollectionTriggers}
          customTriggerOptions={customTriggerOptions}
        />
      </S.DrawerContents>
    </Drawer>
  );
};
